import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import groupBy from 'lodash/groupBy';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import sortBy from 'lodash/sortBy';
import Activity from '../components/ActivityFeed/Activity';
import { queryNotifications } from '../components/buttons/NotificationsButton/myNotificationsQuery';
import { notificationFragment } from '../components/buttons/NotificationsButton/fragments/notificationFragment';
import NavBarNew from '../components/toolbars/NavBarNew';
// TODO: refactor this entire page

const readNotificationMutation = gql`
  mutation readNotification($projectId: String, $notificationId: String) {
    readNotification(projectId: $projectId, notificationId: $notificationId) {
      ...Notification
    }
  }
  ${notificationFragment}
`;

const buildNotification = n => {
  return {
    id: n.id,
    type: n.type,
    user_id: n.user_id,
    activity_id: n.activity_id,
    activity: {
      __typename: 'Activity',
      id: n.activity.id,
      type: n.activity.type,
      subtype: n.activity.subtype,
      subaction: n.activity.subaction,
      objectable_id: n.activity.objectable_id,
      objectable_type: n.activity.objectable_type,
      created_at: n.activity.created_at,
      project_id: n.activity.project_id,
      project: {
        __typename: 'Project',
        id: n.activity.project.id,
        name: n.activity.project.name,
      },
      data: n.activity.data,
      user: {
        id: n.activity.user.id,
        username: n.activity.user.username,
        first_name: n.activity.user.first_name,
        last_name: n.activity.user.last_name,
        avatar: {
          id: n.activity.user.avatar.id,
          path: n.activity.user.avatar.path,
          __typename: 'Avatar',
        },
        __typename: 'User',
      },
    },
    data: n.data,
    status: n.status,
    created_at: n.created_at,
    __typename: 'Notification',
  };
};

const withMutation = graphql(readNotificationMutation, {
  props: props => ({
    readNotificationMutation: (notificationId, projectId) => {
      props.mutate({
        variables: { notificationId, projectId },
        update: (proxy, { data: { readNotification } }) => {
          const query = queryNotifications;
          const variables = { id: notificationId };
          const data = proxy.readQuery({ query, variables });
          readNotification.forEach(rn => {
            const index = data.myNotifications.findIndex(n => n.id === rn.id);
            if (index > -1) data.myNotifications.splice(index, 1);
          });
          proxy.writeQuery({ query, data });
        },
        optimisticResponse: (() => {
          if (props.ownProps.notification) {
            return {
              __typename: 'Mutation',
              readNotification: [
                buildNotification(props.ownProps.notification),
              ],
            };
          } else {
            return {
              __typename: 'Mutation',
              readNotification: (() => {
                return props.ownProps.notifications.map(n => {
                  return buildNotification(n);
                });
              })(),
            };
          }
        })(),
      });
    },
  }),
});
@withMutation
class NotificationItem extends React.Component {
  _onMarkRead = () => {
    const { notification, readNotificationMutation } = this.props;
    readNotificationMutation(notification.id);
  };

  render() {
    const { notification, dispatch } = this.props;

    return (
      <li className="list-group-item d-flex justify-content-between align-items-center">
        <Activity
          key={notification.activity.id}
          activity={notification.activity}
          notificationOverride
          dispatch={dispatch}
          push={push}
        />
        <i
          className="fa fa-check"
          aria-hidden="true"
          onClick={this._onMarkRead}
        />
      </li>
    );
  }
}

@withMutation
class NotificationList extends React.Component {
  _onMarkProjectRead = () => {
    const { notifications, readNotificationMutation } = this.props;
    readNotificationMutation(null, notifications[0].project_id);
  };

  render() {
    const { title, projectId, notifications, dispatch } = this.props;
    return (
      <ul className="list-group mb-3">
        <li
          key={title}
          className="list-group-item d-flex justify-content-between align-items-center"
          style={{ backgroundColor: '#f6f8fa' }}
        >
          <h3 className="mb-0">
            <Link to={`/project/${projectId}`}>{title}</Link>
          </h3>
          <i
            className="fa fa-check"
            aria-hidden="true"
            onClick={this._onMarkProjectRead}
          />
        </li>
        {notifications.map(n => (
          <NotificationItem key={n.id} notification={n} dispatch={dispatch} />
        ))}
      </ul>
    );
  }
}

const withData = graphql(queryNotifications, {
  options: () => ({
    fetchPolicy: 'network-only',
  }),
});

@withData
@connect()
class NotificatonsGroup extends React.Component {
  static propTypes = {
    data: PropTypes.object,
  };

  // componentWillMount() {
  //   const { subscribeToNewNotifications } = this.props;
  //   this.subscription = subscribeToNewNotifications(this.props);
  // }

  // componentWillUnmount() {
  //   this.subscription();
  // }

  render() {
    const {
      data: { loading, myNotifications },
      dispatch,
    } = this.props;

    if (loading) return <div>loading</div>;
    if (myNotifications && myNotifications.length === 0) {
      return <div>You have no unread notifications!</div>;
    }

    const groupedNotifications = groupBy(
      myNotifications,
      'activity.project_id',
    );

    return (
      <div>
        {Object.keys(groupedNotifications).map(projectId => (
          <NotificationList
            projectId={projectId}
            notifications={sortBy(groupedNotifications[projectId], 'id')}
            title={groupedNotifications[projectId][0].activity.project.name}
            dispatch={dispatch}
            key={groupedNotifications[projectId][0].activity.project.id}
          />
        ))}
      </div>
    );
  }
}

export default class NotificationsPage extends React.Component {
  static propTypes = {
    routeParams: PropTypes.object,
  };

  render() {
    return (
      <div className="main-container">
        <NavBarNew />
        <div className="col-xs-12 p-3 clearfix" style={{ marginLeft: 50 }}>
          <h1>Notifications</h1>
          <NotificatonsGroup />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Notifications.js